import { render, staticRenderFns } from "./AnswersPage.vue?vue&type=template&id=7f6b668a&scoped=true&"
import script from "./AnswersPage.js?vue&type=script&lang=js&"
export * from "./AnswersPage.js?vue&type=script&lang=js&"
import style0 from "./AnswersPage.vue?vue&type=style&index=0&id=7f6b668a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b668a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CircleLoader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CircleLoader.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
